const backendUrl = 'https://uniunderflow.vercel.app';

export default backendUrl;
